import React from 'react';
export default function DataTableFilter( {filterText, onClear, onFilter, ...props} ){
  return (<>
    <div className="d-flex justify-content-end">
      <div className="d-flex align-items-center gap-2 col col-md-3 col-lg-2">
        <span className="mdi mdi-filter-outline text-muted"></span>
        <input type="text" className="form-control form-control-sm" name="filterText" value={filterText} placeholder="Filtrovať tabuľku..." onChange={(e)=>onFilter(e)} />
        {filterText && <span className="text-muted clickable" onClick={(e)=>onClear(e)} title="zrušiť filter"><span className="mdi mdi-close"></span></span>}
      </div>
    </div>
  </>);
}
